module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("关于框架")]), _vm._v(" "), _c('h4', {
    staticClass: "fg-cyan no-margin-bottom"
  }, [_vm._v("Metro UI风格")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin-top"
  }, [_vm._v("\n    Metro作为一种文字导向（typography-based）的设计，设计一般采用微软WP为此设计的标准字体：\"Segoe WP\"，它也比起其他UI设计风格更加注重字体，并且在持续不停进化中，原因是Metro的设计原则之一是\"content before chrome\"，翻译过来大致是“内容大于装饰”，所以这种设计风格更加注重应用内容本身（一般以文字和线描图展现），而不是在于传统设计上的“Graphic”（图形），这也是当初它搭配在Lumia上一出世就把大家惊艳到的主要因素。  \n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin-top"
  }, [_vm._v("\n    这种基于瑞士平面设计的设计原则，有利于设计出以文字为主的导航界面。机场和地铁的指示牌给了微软设计团队灵感，其风格大量采用大字体，能吸引观众之注意力。微软认为Metro设计主题应该是：“光滑、快、现代”（Simple.Clean.Modern），于是现在你看到的Metro的图标设计也不同于Android和iOS，即便它还是有不少的传统意义上的图标。 \n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_vm._v("\n    CSS参考："), _c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "https://metroui.org.ua/"
    }
  }, [_vm._v("Metro UI CSS")])]), _vm._v(" "), _c('h4', {
    staticClass: "fg-cyan no-margin-bottom"
  }, [_vm._v("组件引用")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_vm._v("\n    1. 所有组件都以.vue文件形式包含在源码中，可以单独拿出来使用，没有样式依赖。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_vm._v("\n    2. 其中包含四个组件（alert、confirm、message、loading），也可以单独拿出来使用\n  ")]), _vm._v(" "), _c('h4', {
    staticClass: "fg-cyan no-margin-bottom"
  }, [_vm._v("联系作者\b")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel"
  }, [_vm._v("\n    如果有任何疑问，可以通过以下的方式联系作者:\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n    "), _c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "https://www.github.com/watson-yan"
    }
  }, [_vm._v("https://www.github.com/watson-yan")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n    "), _c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "mailto:watson-y@outlook.com"
    }
  }, [_vm._v("watson-y@outlook.com")])]), _vm._v(" "), _c('h4', [_vm._v("如果喜欢整个文档界面风格，附源码:(记得star哦\b\b😆)")]), _vm._v(" "), _c('p', {
    staticClass: "fg-steel no-margin"
  }, [_c('a', {
    staticClass: "fg-steel",
    attrs: {
      "href": "https://github.com/watson-yan/viui-doc",
      "target": "_blank"
    }
  }, [_vm._v("\bGithub地址")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e0b1980"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/about.vue
// module id = 406
// module chunks = 1